import ResponsiveHelper from "../utils/ResponsiveHelper";
import GsapScrollUtils from "../utils/GsapScrollUtils";
import { Modal } from "bootstrap";

export default class PageHome {
  constructor(dom) {
    this.dom = dom;
    this.gsu = null;

    this._boundOnResize = this._onResize.bind(this);
    this._debouncedResize = this._debounce(this._boundOnResize, 150);
    window.addEventListener("resize", this._debouncedResize, { passive: true });

    this.init();
  }
  init() {
    this.initResponsiveHelper();
    this.initGsap();
    this.initLocationBasedModal();
  }

  initResponsiveHelper() {
    this.rHelper = new ResponsiveHelper();
    window.addEventListener("onBreakpointChange", (e) => {
      //console.log(e.detail);
    });
  }

  initGsap() {
    // Enable automatic ScrollTrigger refresh on resize with a sensible debounce
    this.gsu = new GsapScrollUtils({
      autoRefreshOnResize: true,
      resizeDebounce: 120,
    });

    this.gsu.fadeOutOnLeave("[js-anim-fool]", {
      scrub: true,
      markers: false,
      playOnEnterBack: true,
    });

    this.setupHeroTimeline();
    this.setupLocationTimeline();
    this.setupHeroParallax();
    this.setupHorizontalGallery();
    this.setupDesignParallax();
    this.setupDesignTimeline();
    // this.setupEnquireBtn();
    this.setupPin();
  }

  setupHeroTimeline() {
    if (!this.gsu) return;
    if (this.heroTimeline && typeof this.heroTimeline.kill === "function") {
      this.heroTimeline.kill();
      this.heroTimeline = null;
    }

    this.heroTimeline = this.gsu.createTimeline({
      start: "top top",
      end: "bottom top",
      scrub: false,
      markers: false,
      playOnEnterBack: true,
    });

    this.heroTimeline
      .from(".hero-wrapper .logo-wrapper", {
        opacity: 0,
        duration: 0.8,
        ease: "power2.inOut",
      })
      .fromTo(
        ".hero-wrapper .logo-wrapper .wordmark",
        {
          opacity: 1,
        },
        {
          opacity: 0,
          duration: 0.8,
          ease: "power2.inOut",
        },
        "+=1.2",
      )
      .fromTo(
        ".hero-wrapper .text-wrapper h1",
        { y: -60, opacity: 0 },
        { y: -80, opacity: 1, duration: 1.2, ease: "power2.inOut" },
        "-=0.8",
      )
      .fromTo(
        ".hero-wrapper .text-wrapper p",
        { y: -70, opacity: 0 },
        { y: -90, opacity: 1, duration: 1.2, ease: "power2.inOut" },
        "-=0.9",
      )
      .from(
        ".hero-wrapper .scroll-indicator",
        { y: 10, opacity: 0, duration: 0.6, ease: "power2.inOut" },
        "-=0",
      );
  }

  setupHeroParallax() {
    if (!this.gsu) return;

    if (this.heroParallax && typeof this.heroParallax.kill === "function") {
      this.heroParallax.kill();
      this.heroParallax = null;
    }

    const parallaxAmount =
      typeof window !== "undefined" ? window.innerHeight * 0.5 : 500;
    this.heroParallax = this.gsu.fromToWithScroll(
      ".hero-wrapper .hero-video",
      { y: 0, autoAlpha: 1 },
      { y: parallaxAmount, autoAlpha: 1, ease: "none" },
      {
        trigger: ".hero-wrapper",
        start: "top top",
        end: "bottom top",
        scrub: true,
        markers: false,
        playOnEnterBack: true,
      },
    );
  }

  setupLocationTimeline() {
    if (!this.gsu) return;

    if (this.locationImageTL) {
      this.locationImageTL.kill();
      this.locationImageTL = null;
    }
    if (this.locationImageTL2) {
      this.locationImageTL2.kill();
      this.locationImageTL2 = null;
    }
    if (this.locationImageTL3) {
      this.locationImageTL3.kill();
      this.locationImageTL3 = null;
    }

    const img = document.querySelector(
      ".section-location .image-wrapper .bgimage",
    );

    let initialHeight = 0;
    let initialWidth = 0;

    if (this.rHelper.breakpoint === "xs") {
      initialWidth = `${(362 / 402) * 100}vw`;
      initialHeight = 150;
    } else {
      initialWidth = "62.1875vw";
      initialHeight = 260;
    }

    const viewportH = typeof window !== "undefined" ? window.innerHeight : 500;
    const startPercent = (initialHeight / (initialHeight + viewportH)) * 100;

    this.locationImageTL = this.gsu.fromToWithScroll(
      ".section-location .image-wrapper .bgimage.stage-0",
      {
        width: initialWidth,
        height: initialHeight,
        y: 0,
        backgroundPosition: "50% 50%",
        ease: "none",
      },
      {
        width: "100%",
        height: `${viewportH}px`,
        backgroundPosition:
          this.rHelper.breakpoint === "xs" ? "73% 50%" : "50% 50%",
        y: -250,
        ease: "none",
      },
      {
        trigger: ".section-location .image-wrapper",
        start: `top ${30}%`,
        end: "top top",
        scrub: true,
        markers: false,
        playOnEnterBack: true,
      },
    );

    this.locationImageTL2 = this.gsu.fromToWithScroll(
      ".section-location .image-wrapper .bgimage.stage-1",
      {
        width: initialWidth,
        height: initialHeight,
        y: 0,
        backgroundPosition: "50% 50%",
        ease: "none",
      },
      {
        width: "100%",
        height: `${viewportH}px`,
        backgroundPosition:
          this.rHelper.breakpoint === "xs" ? "73% 50%" : "50% 50%",
        y: -250,
        ease: "none",
      },
      {
        trigger: ".section-location .image-wrapper",
        start: `top ${30}%`,
        end: "top top",
        scrub: true,
        markers: false,
        playOnEnterBack: true,
      },
    );

    this.locationImageTL3 = this.gsu.fromToWithScroll(
      ".section-location .image-wrapper .overlay",
      {
        width: initialWidth,
        height: initialHeight,
        y: 0,
        opacity: 0,
        ease: "none",
      },
      {
        width: "100%",
        height: `${viewportH}px`,
        y: -250,
        opacity: 1,
        ease: "none",
      },
      {
        trigger: ".section-location .image-wrapper",
        start: `top ${30}%`,
        end: "top top",
        scrub: true,
        markers: false,
        playOnEnterBack: true,
      },
    );

    this.gsu.toWithScroll(
      ".section-location .image-wrapper .bgimage.stage-0",
      {
        opacity: 0,
        ease: "none",
      },
      {
        trigger: ".section-location .text-wrapper",
        start: `top 30%`,
        end: "top top",
        scrub: true,
        markers: false,
        playOnEnterBack: true,
      },
    );
    this.gsu.toWithScroll(
      ".section-location .image-wrapper .bgimage.stage-1",
      {
        backgroundSize:
          window.innerHeight > window.innerWidth ? "350%" : "180%",
        backgroundPosition:
          this.rHelper.breakpoint === "xs" ? "73% 50%" : "65% 30%",
        ease: "none",
      },
      {
        trigger: ".section-location .text-wrapper",
        start: `top top`,
        end: "top -50%",
        scrub: true,
        markers: false,
        playOnEnterBack: true,
      },
    );

    if (this.locationTextTL) {
      this.locationTextTL.kill();
      this.locationTextTL = null;
    }
    if (this.locationTextTL2) {
      this.locationTextTL2.kill();
      this.locationTextTL2 = null;
    }

    const sectionHeight =
      this.dom.querySelector(".section-location").clientHeight;
    const textWrapperHeight = this.dom.querySelector(
      ".section-location .text-wrapper",
    ).clientHeight;

    this.locationTextTL = this.gsu.createTimeline({
      trigger: ".section-location .image-wrapper",
      start: "top 30%",
      end: "top top",
      scrub: true,
      markers: false,
      playOnEnterBack: true,
      toggleActions: "play none none reverse",
      onToggle: ({ animation }) => {
        if (animation.reversed()) {
          animation.timeScale(-2);
        } else {
          animation.timeScale(1);
        }
      },
    });

    this.locationTextTL
      .fromTo(
        ".section-location .text-wrapper",
        {
          color: "#000000",
          opacity: 1,
        },
        {
          color: "#ffffff",
          opacity: 1,
          duration: 1.2,
          ease: "none",
        },
      )
      .fromTo(
        ".section-location .text-wrapper p",
        {
          opacity: 0,
          y: 20,
        },
        {
          opacity: 1,
          y: 0,
          duration: 1.2,
          ease: "power2.inOut",
        },
        "-=0.8",
      )
      .fromTo(
        ".section-location .text-wrapper a",
        {
          opacity: 0,
          y: 20,
        },
        {
          opacity: 1,
          y: 0,
          duration: 1.2,
          ease: "power2.inOut",
        },
        "-=0.7",
      );

    this.locationTextTL2 = this.gsu.createTimeline({
      trigger: ".section-houses",
      start: "top 120%",
      endTrigger: ".section-houses",
      end: "top bottom",
      scrub: true,
      markers: false,
      playOnEnterBack: true,
      toggleActions: "play none none reverse",
    });

    this.locationTextTL2.fromTo(
      ".section-location .text-wrapper",
      {
        opacity: 1,
        y: 0,
        duration: 1.2,
        ease: "power2.inOut",
      },
      {
        opacity: 0,
        y: "-=20",
        duration: 1.2,
        ease: "power2.inOut",
      },
    );

    this.gsu.fromToWithScroll(
      ".section-houses .text-wrapper",
      {
        opacity: 0,
      },
      {
        opacity: 1,
      },
      {
        trigger: ".section-houses .text-wrapper",
        start: "top 80%",
        end: "bottom bottom",
        ease: "power2.inOut",
        scrub: true,
        markers: false,
        playOnEnterBack: true,
      },
    );
  }

  setupHorizontalGallery() {
    if (!this.gsu) return;

    if (this.horizontalGallery) {
      this.horizontalGallery.kill();
      this.horizontalGallery = null;
    }

    if (this.horizontalGallery2) {
      this.horizontalGallery2.kill();
      this.horizontalGallery = null;
    }

    const horizontalImagesWrapper = this.dom.querySelector(
      ".tower-1 .horizontal-wrapper .images-wrapper",
    );
    const horizontalWidth =
      horizontalImagesWrapper.clientWidth - window.innerWidth;

    this.horizontalGallery = this.gsu.fromToWithScroll(
      ".tower-1 .horizontal-wrapper .images-wrapper",
      { x: 0 },
      { x: `-${horizontalWidth}px`, ease: "none" },
      {
        trigger: ".pin-wrapper-t1",
        start: "top top",
        end: `bottom bottom`,
        scrub: true,
        pin: true,
        markers: false,
        playOnEnterBack: true,
      },
    );

    this.gsu.fromToWithScroll(
      ".tower-1 .horizontal-wrapper .images-wrapper img.one",
      { x: 100, autoAlpha: 1 },
      { x: 60, autoAlpha: 1, ease: "none" },
      {
        trigger: ".pin-wrapper-t1",
        start: "top top",
        end: "bottom bottom",
        scrub: true,
        markers: false,
        playOnEnterBack: true,
      },
    );
    this.gsu.fromToWithScroll(
      ".tower-1 .horizontal-wrapper .images-wrapper img.two",
      { x: 250, autoAlpha: 1 },
      { x: 20, autoAlpha: 1, ease: "none" },
      {
        trigger: ".pin-wrapper-t1",
        start: "top top",
        end: "bottom bottom",
        scrub: true,
        markers: false,
        playOnEnterBack: true,
      },
    );
    this.gsu.fromToWithScroll(
      ".tower-1 .horizontal-wrapper .images-wrapper img.three",
      { x: 50, autoAlpha: 1 },
      { x: 0, autoAlpha: 1, ease: "none" },
      {
        trigger: ".pin-wrapper-t1",
        start: "top top",
        end: "bottom bottom",
        scrub: true,
        markers: false,
        playOnEnterBack: true,
      },
    );
    this.gsu.fromToWithScroll(
      ".tower-1 .horizontal-wrapper .images-wrapper img.four",
      { x: -20, autoAlpha: 1 },
      { x: 40, autoAlpha: 1, ease: "none" },
      {
        trigger: ".pin-wrapper-t1",
        start: "top top",
        end: "bottom bottom",
        scrub: true,
        markers: false,
        playOnEnterBack: true,
      },
    );
    this.gsu.fromToWithScroll(
      ".tower-1 .horizontal-wrapper .images-wrapper img.five",
      { x: 40, autoAlpha: 1 },
      { x: -40, autoAlpha: 1, ease: "none" },
      {
        trigger: ".pin-wrapper-t1",
        start: "top top",
        end: "bottom bottom",
        scrub: true,
        markers: false,
        playOnEnterBack: true,
      },
    );

    //========= tower 2 ===========
    const horizontalImagesWrapper2 = this.dom.querySelector(
      ".tower-2 .horizontal-wrapper .images-wrapper",
    );
    const horizontalWidth2 =
      horizontalImagesWrapper2.clientWidth - window.innerWidth;

    this.horizontalGallery2 = this.gsu.fromToWithScroll(
      ".tower-2 .horizontal-wrapper .images-wrapper",
      { x: `${-horizontalWidth2}px` },
      { x: 0, ease: "none" },
      {
        trigger: ".pin-wrapper-t2",
        start: "top top",
        end: `bottom bottom`,
        scrub: true,
        pin: true,
        markers: false,
        playOnEnterBack: false,
      },
    );

    this.gsu.fromToWithScroll(
      ".tower-2 .horizontal-wrapper .images-wrapper img.one",
      { x: -50, autoAlpha: 1 },
      { x: 0, autoAlpha: 1, ease: "none" },
      {
        trigger: ".pin-wrapper-t2",
        start: "top top",
        end: "bottom bottom",
        scrub: true,
        markers: false,
        playOnEnterBack: true,
      },
    );
    this.gsu.fromToWithScroll(
      ".tower-2 .horizontal-wrapper .images-wrapper img.two",
      { x: -250, autoAlpha: 1 },
      { x: -20, autoAlpha: 1, ease: "none" },
      {
        trigger: ".pin-wrapper-t2",
        start: "top top",
        end: "bottom bottom",
        scrub: true,
        markers: false,
        playOnEnterBack: true,
      },
    );
    this.gsu.fromToWithScroll(
      ".tower-2 .horizontal-wrapper .images-wrapper img.three",
      { x: -100, autoAlpha: 1 },
      { x: -60, autoAlpha: 1, ease: "none" },
      {
        trigger: ".pin-wrapper-t2",
        start: "top top",
        end: "bottom bottom",
        scrub: true,
        markers: false,
        playOnEnterBack: true,
      },
    );
    this.gsu.fromToWithScroll(
      ".tower-2 .horizontal-wrapper .images-wrapper img.four",
      { x: 20, autoAlpha: 1 },
      { x: -40, autoAlpha: 1, ease: "none" },
      {
        trigger: ".pin-wrapper-t2",
        start: "top top",
        end: "bottom bottom",
        scrub: true,
        markers: false,
        playOnEnterBack: true,
      },
    );
    this.gsu.fromToWithScroll(
      ".tower-2 .horizontal-wrapper .images-wrapper img.five",
      { x: -40, autoAlpha: 1 },
      { x: 40, autoAlpha: 1, ease: "none" },
      {
        trigger: ".pin-wrapper-t2",
        start: "top top",
        end: "bottom bottom",
        scrub: true,
        markers: false,
        playOnEnterBack: true,
      },
    );
  }

  setupDesignParallax() {
    if (!this.gsu) return;

    if (this.designParallax) {
      this.designParallax.kill();
      this.designParallax = null;
    }

    const parallaxAmount =
      typeof window !== "undefined" ? window.innerHeight * 0.5 : 500;
    this.designParallax = this.gsu.fromToWithScroll(
      ".pin-wrapper-2 .image-wrapper",
      { backgroundPositionY: `${parallaxAmount}px`, autoAlpha: 1 },
      { backgroundPositionY: "0px", autoAlpha: 1, ease: "none" },
      {
        trigger: ".section-towers",
        start: "bottom bottom",
        end: "bottom top",
        scrub: true,
        markers: false,
        playOnEnterBack: true,
      },
    );
  }

  setupDesignTimeline() {
    if (!this.gsu) return;

    if (this.designTextTL) {
      this.designTextTL.kill();
      this.designTextTL = null;
    }

    if (this.designTextTL2) {
      this.designTextTL2.kill();
      this.designTextTL2 = null;
    }

    this.designTextTL = this.gsu.fromToWithScroll(
      ".section-design .text-wrapper",
      {
        opacity: 0,
      },
      {
        opacity: 1,
      },
      {
        trigger: ".section-design .text-wrapper",
        start: "top 80%",
        end: "bottom bottom",
        ease: "power2.inOut",
        scrub: true,
        markers: false,
        playOnEnterBack: true,
      },
    );

    this.designTextTL2 = this.gsu.fromToWithScroll(
      ".section-enquiry .content-wrapper",
      {
        opacity: 0,
      },
      {
        opacity: 1,
      },
      {
        trigger: ".section-enquiry .content-wrapper",
        start: "top 80%",
        end: "top 65%",
        ease: "power2.inOut",
        scrub: true,
        markers: false,
        playOnEnterBack: true,
      },
    );
  }

  setupEnquireBtn() {
    const enquireBtn = document.querySelector(".btn-enquire");
    if (!enquireBtn) return;

    this.gsu.createScrollTrigger({
      trigger: ".section-location",
      start: "top top",
      endTrigger: ".section-enquiry",
      end: "top bottom",
      scrub: true,
      markers: false,
      playOnEnterBack: true,
      onUpdate: (self) => {
        if (self.isActive) {
          enquireBtn.classList.remove("btn--hidden");
        } else {
          enquireBtn.classList.add("btn--hidden");
        }
      },
    });
  }

  setupPin() {
    if (!this.gsu) return;

    this.gsu.createPin({
      pin: ".section-location .image-wrapper",
      trigger: ".pin-wrapper",
      start: "top top",
      end: "bottom -200%",
      markers: false,
    });

    this.gsu.createPin({
      pin: ".section-location .text-wrapper",
      trigger: ".section-location",
      start: "top top",
      endTrigger: ".section-houses",
      end: "top bottom",
      markers: false,
    });

    this.gsu.createPin({
      pin: ".section-houses .text-wrapper",
      trigger: ".section-houses",
      start: "bottom bottom",
      endTrigger: ".section-towers",
      end: "bottom bottom",
      pinSpacing: false,
      markers: false,
    });

    // this.gsu.createPin({
    //   pin: ".towers-wrapper",
    //   trigger: ".section-towers",
    //   start: "top top",
    //   end: "bottom bottom",
    //   pinSpacing: false,
    //   markers: false,
    // });

    this.gsu.createPin({
      pin: ".section-towers.tower-1",
      trigger: ".pin-wrapper-t1",
      start: "top top",
      end: "bottom bottom",
      markers: false,
    });

    this.gsu.createPin({
      pin: ".section-towers.tower-2",
      trigger: ".pin-wrapper-t2",
      start: "top top",
      end: "bottom bottom",
      markers: false,
    });

    this.gsu.createPin({
      pin: ".pin-wrapper-2 .image-wrapper",
      trigger: ".pin-wrapper-2",
      start: "top top",
      end: "bottom bottom",
      pinSpacing: false,
      markers: false,
    });
  }

  setGsapReplay(allow) {
    if (this.gsu && typeof this.gsu.killAll === "function") {
      this.gsu.killAll();
    }
    this.initGsap();
  }

  initLocationBasedModal() {
    const modalElement = document.getElementById("rsvp-popup");
    const dedicatedTimezone = modalElement.dataset.timezone;
    if (modalElement) {
      //Check "TZ identifier" values of Type "Canonical"
      //https://en.wikipedia.org/wiki/List_of_tz_database_time_zones#List

      const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (
        dedicatedTimezone.toLowerCase().trim() !== "all" &&
        userTimezone !== dedicatedTimezone
      ) {
        modalElement.remove();
      } else {
        window.setTimeout(() => {
          Modal.getOrCreateInstance(modalElement).show();
        }, 4500);
      }
    }
  }

  resize() {
    // Public resize entrypoint: delegate to the debounced handler so callers
    // (or tests) can request a resize recalculation without spamming events.
    if (this._debouncedResize) {
      this._debouncedResize();
    } else if (this._boundOnResize) {
      this._boundOnResize();
    }
  }

  _onResize() {
    if (this.gsu) {
      // Wait for layout to settle, then recreate size-dependent animations.
      window.requestAnimationFrame(() => {
        try {
          if (
            this.threeCanvas &&
            typeof this.threeCanvas.resize === "function"
          ) {
            this.threeCanvas.resize();
          }

          if (typeof this.setupHeroTimeline === "function") {
            // this.setupHeroTimeline();
          }

          if (typeof this.setupLocationTimeline === "function")
            this.setupLocationTimeline();
          if (typeof this.setupHeroParallax === "function")
            this.setupHeroParallax();
          if (typeof this.setupHorizontalGallery === "function")
            this.setupHorizontalGallery();
          if (typeof this.setupDesignParallax === "function")
            this.setupDesignParallax();
          if (typeof this.setupDesignTimeline === "function")
            this.setupDesignTimeline();

          // Let GsapScrollUtils refresh ScrollTrigger measurements (it calls ScrollTrigger.refresh())
          this.gsu.handleResize();
        } catch (e) {
          // eslint-disable-next-line no-console
          console.warn("PageHome: error during resize handling", e);
        }
      });
    } else {
      if (this.threeCanvas && typeof this.threeCanvas.resize === "function") {
        this.threeCanvas.resize();
      }
    }
  }

  _debounce(fn, wait = 1000) {
    let timeout = null;
    return (...args) => {
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        timeout = null;
        try {
          fn.apply(this, args);
        } catch (e) {
          // eslint-disable-next-line no-console
          console.warn("PageHome: debounce callback error", e);
        }
      }, wait);
    };
  }
}
